"use strict";
module.exports = require('../../module.compiled').vendored['react-rsc'].ReactDOM;

//# sourceMappingURL=react-dom.js.map